<template>
    <div class="year-frame-container container default-table">
        <div>
            <el-form :inline="true" :model="formQuery" size="mini" class="demo-form-inline">
                <el-form-item label="客户名称">
                    <customer-remote-select multiple :model-value.sync="formQuery.customer_id"/>
                </el-form-item>
                <el-form-item label="销售" v-if="pageForUser===MapPageForUser.UserAuditor">
                    <PinYinMatchSelect :data="optionSales" :is-multiple="true" placeholder="销售"
                                       :model-value.sync="formQuery.creator_id" @focus="getOptionSales"/>
                </el-form-item>
                <el-form-item label="状态">
                    <el-checkbox-group v-model="formQuery.status_custom" class="status-checkbox">
                        <el-checkbox v-for="(obj,key) in MapStatusShow" :key="key" :label="key" :disabled="obj.disable">
                            {{ obj.label }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="签约年度">
                    <el-select v-model="formQuery.year" filterable placeholder="签约周期包含在内的年份" clearable>
                        <el-option v-for="item in MapYears" :key="item" :label="item" :value="item"/>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formQuery.dates_type" filterable placeholder="时间类型" style="width: 100px;">
                        <el-option v-for="(item,field) in MapTypeDate" :key="field" :label="item" :value="field"/>
                    </el-select>
                    <el-date-picker
                            v-model="formQuery.dates"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handelSearch">查询</el-button>
                    <el-button @click="handelResetQuery">重置</el-button>
                </el-form-item>
                <el-form-item v-permission="'can_year_frame_export'" style="float: right">
                    <year-frame-export ref="export" :search="formQuery" @start="handelExport"/>
                </el-form-item>
            </el-form>
        </div>
        <el-tabs v-model="tabStatusIndex" size="mini" type="card" @tab-click="handleTabClick" class="tab-status">
            <el-tab-pane v-for="(item,key) in MapTab" :key="key" :label="item.label" :name="key"/>
        </el-tabs>
        <div class="main">
            <el-tabs v-if="tabStatusIndex!=='ALL'" v-model="tabTypeIndex" size="mini" @tab-click="handleTabClick">
                <el-tab-pane :key="'TO_Y'" :name="'TO_Y'">
                    <el-badge slot="label" :value="num.num_to_y" :hidden="!num.num_to_y" class="item">
                        <span>年框申请</span>
                    </el-badge>
                </el-tab-pane>
                <el-tab-pane :key="'TO_N'" :name="'TO_N'">
                    <el-badge slot="label" :value="num.num_to_n" :hidden="!num.num_to_n" class="item">
                        <span>年框取消</span>
                    </el-badge>
                </el-tab-pane>
            </el-tabs>

            <ApeTable ref="apeTable"
                      class="table"
                      :key="'table-'+key"
                      :data="tableData"
                      :loading="loadingTable"
                      :pagingData="pagingData"
                      :is-full-height="true"
                      @switchPaging="getTableData"
                      @changeTableSort="changeTableSort"
                      highlight-current-row
                      border>
                <el-table-column slot="first-column" align="center" width="50" label="No" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="客户名称" align="left" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.customer && scope.row.customer.name ? scope.row.customer.name : '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="集团" align="left" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.combine && scope.row.combine.name ? scope.row.combine.name : '-' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="tabStatusIndex==='ALL'" prop="customer_name" label="类型" align="center"
                                 width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type==='TO_N'" type="danger" effect="plain">取消年框</el-tag>
                        <el-tag v-else type="warning" effect="plain">申请年框</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-if="tabStatusIndex!=='WAIT'" prop="status" label="状态" align="center" width="80">
                    <template slot-scope="scope">
            <span v-if="MapStatusShow[scope.row.status]" :style="`color:${MapStatusShow[scope.row.status].color}`">
              {{ MapStatusShow[scope.row.status].label }}
            </span>
                        <span v-else>未知</span>
                    </template>
                </el-table-column>
                <el-table-column prop="customer_name" label="开拓者" align="center" width="80">
                    <template slot-scope="scope">
                        {{
                        scope.row.customer && scope.row.customer.pioneer_name ? scope.row.customer.pioneer_name : '-'
                        }}
                    </template>
                </el-table-column>
                <el-table-column v-if="pageForUser===MapPageForUser.UserAuditor" label="销售" align="center" width="80"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ Array.isArray(scope.row.then_sales) ? scope.row.then_sales.join('、') : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="creator" label="申请人" align="center" width="110"/>
                <el-table-column prop="sign_begin" label="签约开始" align="center" width="110" sortable/>
                <el-table-column prop="sign_end" label="签约截至" align="center" width="110" sortable/>
                <el-table-column prop="policy_alias" label="年框政策" min-width="120" align="center"
                                 show-overflow-tooltip/>
                <el-table-column prop="pay_method" label="付款方式" align="center" min-width="100"
                                 show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{
                        row.pay_method && row.pay_method_sub ? row.pay_method + '-' + row.pay_method_sub : row.pay_method
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="charge_person" label="最高级别负责人" align="center" min-width="100"/>
                <el-table-column prop="post" label="职位" align="center" min-width="100"/>
                <el-table-column prop="created_at" label="申请时间" align="center" width="135" sortable/>
                <el-table-column prop="audit_at" label="审核时间" align="center" width="135" sortable/>
                <el-table-column label="说明" min-width="110" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.creator_remark">申请人：{{ scope.row.creator_remark }}；&nbsp;</span>
                        <span v-if="scope.row.audit_remark">审核人：{{ scope.row.audit_remark }}</span>
                    </template>
                </el-table-column>
                <template>
                    <!--   审核人    -->
                    <template v-if="pageForUser===MapPageForUser.UserAuditor">
                        <el-table-column v-if="tabStatusIndex==='WAIT'" fixed="right" class-name="handel-column"
                                         label="审核操作"
                                         align="center" width="180"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <template v-if="scope.row.status===MapStatus.WAIT&&userAuth.can_year_frame_status">
                                    <el-popover placement="left" @hide="handelAudit(scope.row,false,'pass')"
                                                :ref="`popover-audit-pass-${scope.row.id}`" style="margin-right: 15px;">
                                        <template>
                                            <p style="text-align: center;font-weight: bolder;">确定通过该申请吗？</p>
                                            <div style="text-align: center; margin: 0">
                                                <el-button size="mini" type="text"
                                                           @click="handelAudit(scope.row,false,'pass')">取消
                                                </el-button>
                                                <el-button type="primary" size="mini"
                                                           @click="handelAudit(scope.row,true,'pass')">确定
                                                </el-button>
                                            </div>
                                        </template>
                                        <el-radio slot="reference"
                                                  :disabled="!hasAuditHandel(scope.row.status,MapStatus.PASS)"
                                                  v-model="scope.row.custom_audit"
                                                  :label="MapStatus.PASS" @change="handelAuditRadio(scope.row,'pass')">
                                            通过
                                        </el-radio>
                                    </el-popover>
                                    <el-popover placement="left" @hide="handelAudit(scope.row,false,'reject')"
                                                :ref="`popover-audit-reject-${scope.row.id}`">
                                        <template>
                                            <p style="text-align: center;font-weight: bolder;">确定拒绝该申请吗？</p>
                                            <el-input type="textarea" :rows="5" placeholder="请输入拒绝的原因"
                                                      maxlength="100"
                                                      show-word-limit
                                                      v-model="scope.row.custom_audit_remark"
                                                      style="margin-bottom: 10px;"/>
                                            <div style="text-align: center; margin: 0">
                                                <el-button size="mini" type="text"
                                                           @click="handelAudit(scope.row,false,'reject')">取消
                                                </el-button>
                                                <el-button type="primary" size="mini"
                                                           @click="handelAudit(scope.row,true,'reject')">确定
                                                </el-button>
                                            </div>
                                        </template>
                                        <el-radio slot="reference"
                                                  :disabled="!hasAuditHandel(scope.row.status,MapStatus.REJECT)"
                                                  v-model="scope.row.custom_audit"
                                                  :label="MapStatus.REJECT"
                                                  @change="handelAuditRadio(scope.row,'reject')">拒绝
                                        </el-radio>
                                    </el-popover>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                    <!--   申请人    -->
                    <template v-else>
                        <el-table-column fixed="right" class-name="handel-column" label="操作" align="center"
                                         width="120">
                            <template slot-scope="scope">
                                <el-button
                                        v-if="scope.row.status===MapStatus.WAIT&&scope.row.type===MapType.TO_Y&&userAuth.can_year_frame_add"
                                        type="text" size="mini"
                                        style="margin-right: 4px;" @click="handelApply(scope.row,scope.row.type,true)">
                                    编辑
                                </el-button>
                                <!--      撤回        -->
                                <el-popover v-if="scope.row.status===MapStatus.WAIT&&userAuth.can_year_frame_undo"
                                            placement="left"
                                            :ref="`popover-undo-${scope.row.id}`"
                                            :key="`popover-undo-${scope.row.id}-${handelKey}`">
                                    <template>
                                        <p style="text-align: center;font-weight: bolder;">确定撤回该申请吗？</p>
                                        <div style="text-align: center; margin: 0">
                                            <el-button size="mini" type="text" @click="handelUndo(scope.row.id,false)">
                                                取消
                                            </el-button>
                                            <el-button type="primary" size="mini"
                                                       @click="handelUndo(scope.row.id,true)">确定
                                            </el-button>
                                        </div>
                                    </template>
                                    <el-button slot="reference" type="text" size="mini">撤回</el-button>
                                </el-popover>
                                <!--      编辑再提交        -->
                                <el-button
                                        v-if="(scope.row.status===MapStatus.REJECT||scope.row.status===MapStatus.CANCEL)&&userAuth.can_year_frame_add&&scope.row.type===MapType.TO_Y"
                                        type="text" size="mini" @click="handelApply(scope.row,scope.row.type)">编辑再提交
                                </el-button>
                            </template>
                        </el-table-column>
                    </template>
                </template>
                <el-link v-permission="'year_frame_schedule_list'" slot="footer" type="primary"
                         href="/project/yearFrameSchedule" target="_blank">链接：年框进度
                </el-link>
            </ApeTable>
        </div>

        <apply ref="apply" :show.sync="dialogApply" :origin-form="dialogApplyForm" :type="dialogApplyForm.type||'TO_Y'"
               :aim="aim" @success="getTableData"/>
    </div>
</template>

<script>
import CustomerRemoteSelect from "@/views/custom/components/CustomerRemoteSelect";
import ApeTable from "@/components/ApeTable";
import Apply from "./apply.vue";
import {saleOptions} from "@/api/user";
import {pagingData} from "@/config/business";
import {yearFrameAudit, yearFrameList, yearFrameUndo} from "@/api/customerYearFrame";
import {YEAR_FRAME_COMBINE, YEAR_FRAME_CUSTOMER} from "@/config/business/code";
import YearFrameExport from "@/views/custom/components/yearFrame/export.vue";
import moment from "moment";

const MapStatus = {
    WAIT: 0,
    PASS: 1,
    REJECT: 2,
    CANCEL: 3,
}
const MapTab = {
    WAIT: {label: '待审核', value: [MapStatus.WAIT]},
    DONE: {label: '已审核', value: [MapStatus.PASS, MapStatus.REJECT]},
    ALL: {label: '全部', value: null},
}
const MapStatusShow = {
    [MapStatus.WAIT]: {label: '待审核', color: '#409eff', disable: false},
    [MapStatus.PASS]: {label: `通过`, color: '#67c23a', disable: false},
    [MapStatus.REJECT]: {label: '拒绝', color: '#f56c6c', disable: false},
    [MapStatus.CANCEL]: {label: '撤回', color: '#909399', disable: false},
}
const MapPageForUser = {
    UserAuditor: 'auditor', // 给 审核人用
    UserProposer: 'proposer', // 给 申请人用
}
const ModelFormQuery = {
    customer_id: null,
    creator_id: null,
    type: null,
    year: null,
    dates: [],
    dates_type: 'created_at',
    status: [],
    status_custom: [],
    order_by: 'id desc',
}
const MapType = {
    TO_Y: 'TO_Y',
    TO_N: 'TO_N',
}
const MapAim = {
    AIM_CUSTOMER: 'CUSTOMER',
    AIM_COMBINE: 'COMBINE',
};
const ModelNum = {
    num_to_n: 0,
    num_to_y: 0,
}
const MapYears = []
for (let i = 0, year = ((moment().year()) + 2); i < 8; i++, year--) {
    MapYears.push(year)
}
const MapTypeDate = {
    audit_at: '审核时间',
    created_at: '申请时间',
    sign_begin: '签约开始',
    sign_end: '签约结束',
}

export default {
    name: "YearFrame",
    components: {YearFrameExport, CustomerRemoteSelect, ApeTable, Apply},
    data() {
        return {
            MapTab,
            MapType,
            MapYears,
            MapStatus,
            MapTypeDate,
            MapStatusShow,
            MapPageForUser,
            pagingData,
            tabStatusIndex: 'WAIT',
            tabTypeIndex: MapType.TO_Y,
            key: new Date().getTime(),
            handelKey: new Date().getTime(),
            loadingTable: false,
            dialogApply: false,
            dialogApplyForm: {},
            pageForUser: MapPageForUser.UserProposer,
            tableData: [],
            optionSales: [],
            aim: null,
            formQuery: {...{}, ...ModelFormQuery},
            num: {...{}, ...ModelNum}
        }
    },
    computed: {
        userAuth() {
            return this.$store.getters.getUserAuth;
        },
    },
    watch: {
        '$route.query.hand': function () {
            this.setPageForUser()
            this.getTableData()
        },
        tabStatusIndex() {
            this.setDisableStatus()
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.setDisableStatus()
            this.setPageForUser()
            this.getTableData()
            this.getOptionSales()
        },
        setDisableStatus() {
            this.formQuery.status_custom = []
            let disabled = []
            switch (this.tabStatusIndex) {
                case 'WAIT':
                    disabled = [MapStatus.PASS, MapStatus.REJECT, MapStatus.CANCEL]
                    break;
                case 'DONE':
                    disabled = [MapStatus.WAIT, MapStatus.CANCEL]
                    break;
            }
            for (const k in MapStatusShow) {
                this.MapStatusShow[k].disable = (disabled.findIndex(item => item == k) > -1)
            }
            this.key = new Date().getTime()
        },
        handelSearch() {
            this.getTableData()
        },
        handelResetQuery() {
            this.formQuery = {...{}, ...ModelFormQuery};
            this.handelSearch()
        },
        handleTabClick() {
            this.handelSearch();
        },
        handelExport() {
            this.$refs.export && this.$refs.export.handelStart(this.assembleQueryParams())
        },
        /**
         * 是否操作按钮
         * @param status
         * @param audit
         * @returns {boolean}
         */
        hasAuditHandel(status, audit) {
            let bool = false
            switch (status) {
                case MapStatus.WAIT:
                    bool = true;
                    break;
                case MapStatus.PASS:
                    bool = audit === MapStatus.PASS;
                    break;
                case MapStatus.REJECT:
                    bool = audit === MapStatus.REJECT;
                    break;
                case MapStatus.CANCEL:
                    break;
            }
            return bool;
        },
        handelAuditRadio(obj, type) {
            this.$refs[`popover-audit-${type}-` + obj.id].showPopper = true;
        },
        /**
         * 审核操作
         * @param obj 行数据
         * @param isSure 确认/取消
         * @param type 通过/拒绝
         * @returns {Promise<boolean>}
         */
        async handelAudit(obj, isSure, type) {
            if (!isSure) {
                obj.custom_audit = MapStatus.WAIT;
                this.$refs[`popover-audit-${type}-` + obj.id].showPopper = false;
                return false;
            }

            const that = this;
            const params = {
                id: obj.id,
                status: obj.custom_audit,
                audit_remark: obj.custom_audit_remark
            }
            if (params.status === MapStatus.REJECT && !params.audit_remark) {
                this.showToast({h: this, icon: "el-icon-error", text: '请填写拒绝的原因', duration: 1000});
                return false;
            }

            const response = await yearFrameAudit(params);
            this.$refs[`popover-audit-${type}-` + obj.id].showPopper = false;
            if (!response.success) {
                const tipOption = {
                    type: 'error',
                    confirmButtonText: '前往处理',
                    cancelButtonText: '知道了',
                    showClose: false
                }
                if (response.code === YEAR_FRAME_CUSTOMER) {
                    await that.$msgbox.confirm(`请为该集团【${response.message}】申请或审核年框`, '操作失败，该客户已归属集团', tipOption).then(() => {
                        that.$router.push('/project/combine_customer')
                    });
                    return false;
                }
                if (response.code === YEAR_FRAME_COMBINE) {
                    await this.$msgbox.confirm(`【${response.message}】是年框客户，【客户详情->年框信息->年框记录】模块，【撤回】【${response.message}】的年框`, '操作失败，该集团下已存在年框客户', tipOption).then(() => {
                        that.$router.push({name: 'yearFrameProposer', query: {hand: 'proposer'}})
                    });
                    return false;
                }
                this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
                return false;
            }
            this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
            await this.getTableData()
        },
        /**
         * 编辑再提交||取消
         * @desc 点击事件
         * @param obj
         * @param type
         * @param is_update
         */
        async handelApply(obj, type = MapType.TO_Y, is_update = false) {
            obj.custom_customer_name = obj.customer && obj.customer.name ? obj.customer.name : null;
            obj.custom_combine_name = obj.combine && obj.combine.name ? obj.combine.name : null;
            obj.custom_sign_date_array = [obj.sign_begin, obj.sign_end];

            // 目标
            if (!obj.custom_customer_name) {
                this.aim = MapAim.AIM_COMBINE
            } else {
                this.aim = MapAim.AIM_CUSTOMER
            }

            this.dialogApply = true
            this.dialogApplyForm = {...{}, ...obj}
            this.dialogApplyForm.is_update = is_update;
            this.dialogApplyForm.type = type;
            // this.dialogApplyForm.origin_id = obj.id;
        },
        /**
         * 撤回
         * @desc 点击事件
         * @param id
         * @param isSure
         * @returns {Promise<boolean>}
         */
        async handelUndo(id, isSure) {
            this.$refs["popover-undo-" + id].showPopper = false;
            this.handelKey = new Date().getTime()
            if (!isSure) {
                return false;
            }
            const response = await yearFrameUndo({id});
            if (!response.success) {
                this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
                return false;
            }
            this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
            await this.getTableData()
        },
        /**
         * 设置当前页面是给审核人还是申请人用
         * @desc 入口不同、路由携带参数
         */
        setPageForUser() {
            this.pageForUser = this.$route.query.hand || MapPageForUser.UserAuditor
            this.key = new Date().getTime()
        },
        /**
         * 组装查询条件
         * @returns {{[p: string]: *}}
         */
        assembleQueryParams() {
            let pagingInfo = this.$refs['apeTable'].getPagingInfo()
            const params = {...pagingInfo, ...this.formQuery}
            params.count = null;
            params.page = params.current_page
            if (this.pageForUser === MapPageForUser.UserProposer) {
                // 如果当前页面为申请页面，则只看到自己的申请
                const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
                params.creator_id = [user.id]
            } else {
                // 如果页面为审核人
                if (this.tabStatusIndex === 'WAIT') {
                    params.count = true;
                }
            }

            if (this.tabStatusIndex === 'ALL') {
                params.type = null
            } else {
                params.type = this.tabTypeIndex
            }

            if (Array.isArray(this.formQuery.status_custom) && this.formQuery.status_custom.length) {
                params.status = this.formQuery.status_custom
            } else {
                params.status = MapTab[this.tabStatusIndex].value
            }
            return params;
        },
        /**
         * table接口
         * @returns {Promise<void>}
         */
        async getTableData() {
            this.num = {...{}, ...ModelNum}
            this.loadingTable = true
            const response = await yearFrameList(this.assembleQueryParams())
            this.loadingTable = false

            if (!response.success) {
                this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
                return;
            }
            const array = response.model.data || [];
            array.map(datum => {
                datum.custom_audit = datum.status
                datum.custom_audit_remark = null
                datum.visible = false
            })

            this.tableData = array;
            this.pagingData.total = response.model.total;
            this.num = {num_to_n: response.model.num_to_n || 0, num_to_y: response.model.num_to_y || 0,}

        },
        changeTableSort({order, prop}) {
            order = order === 'ascending' ? 'asc' : 'desc'
            this.formQuery.order_by = `${prop} ${order}`
            this.getTableData()
        },
        async getOptionSales() {
            const response = await saleOptions()
            this.optionSales = response.model;
        }
    }
}
</script>

<style lang="scss">
.year-frame-container {
  padding: 20px;
  height: calc(100vh - 215px);

  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    font-weight: bold;
  }

  .el-badge__content.is-fixed {
    font-size: 12px;
    width: 14px;
    height: 14px;
    line-height: 14px;
    padding: 1px 2px;
    top: 7px;
    right: 4px;
  }

  .tab-status {
    .el-tabs__item {
      font-size: 15px;
    }
  }

  .main {
    padding: 10px 20px;
    border: 1px solid #E4E7ED;
    border-top: none;
    height: 100%;

    .el-tabs {
      border-bottom: 1px solid #E4E7ED;
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }

    .el-table--border {
      border-top: none;
    }

    .table {
      height: calc(100% - 30px) !important;

      .el-table {
        height: calc(100% - 30px) !important;
      }
    }
  }

  .close-btn {
    top: -13px;
  }

  .handel-column {
    button {
      padding: 0;
    }
  }

  .status-checkbox {
    height: 28px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding-left: 4px;

    .el-checkbox {
      margin-right: 8px;

      .el-checkbox__label {
        padding-left: 4px;
      }
    }
  }
}
</style>
